import { render, staticRenderFns } from "./AgencyContestForms.vue?vue&type=template&id=4c1ce6c5&scoped=true&"
import script from "./AgencyContestForms.vue?vue&type=script&lang=js&"
export * from "./AgencyContestForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1ce6c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
installComponents(component, {VCard,VContainer})
